import Profile from './Profile'
import * as selectors from './profile.selectors'
import slice from './profile.slice'

export const { name, reducer } = slice

export const { selectUser, selectIsSales, selectIsAdmin } = selectors

export default Profile
